import React from "react";
import SignUpPregressBar from "../../components/common/signup progress bar/SignUpPregressBar";
import ClubDetailForm from "./ClubDetailForm";
import FormLayout from "./Layout/form layout/FormLayout";

const ClubDetail = () => {
  return (
    <section className=" club_Login">
      <div className="page-width">
        <FormLayout heading="Club Sign Up">
          <div className="club_Login__wrapper-block">
            <SignUpPregressBar />
            <ClubDetailForm />
          </div>
        </FormLayout>
      </div>
    </section>
  );
};

export default ClubDetail;
